<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab>
                <template slot="title">
                    <i class="icon-globe mr-2"></i>{{Core.Definition.getDefinition('Général')}}
                </template>
                <DynamicForm
                        class="mt-3"
                        ref="event"
                        @onRequestSuccess="onRequestSuccess"
                        getRoot="/setting/event-general"
                        saveRoot="/setting/event-general"
                        :formStructure="dataFormStructures.general">
                </DynamicForm>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import nav from '../../_nav'
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from '../../../components/DynamicForm'
    import InputText from '../../../components/InputText'
    import draggable from 'vuedraggable'
    export default {
        name: 'SettingsEvent',
        components: {
            DynamicForm,
            draggable,
            InputText
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataCategories: [],
                dataFormStructures: {
                    general: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Type d\'événement'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'types'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Filtre de recherche'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'filterBranch'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'filterEvent'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'filterType'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'filterResponsable'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'filterProduct'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'filterPlugin'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'forceFilter'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Options avancées'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'responsableRoles'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'virtualEventIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'placeIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'seasonIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'leagueIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'types',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Types d\'événement disponibles'),
                                value: null,
                                onSelect: function () {}
                            },
                            {
                                id: 'responsableRoles',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Rôles des responsables'),
                                value: null,
                                onSelect: function () {}
                            },
                            {
                                id: 'placeIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des lieux'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'seasonIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des saisons'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'leagueIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des ligues'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'virtualEventIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la gestion des événements virtuels'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'filterBranch',
                                type: 'checkbox',
                                value: null,
                                label: Core.Definition.getDefinition('Activer la recherche établissement'),
                                onChange: function () {}
                            },
                            {
                                id: 'filterEvent',
                                type: 'checkbox',
                                value: null,
                                label: Core.Definition.getDefinition('Activer la recherche événement'),
                                onChange: function () {}
                            },
                            {
                                id: 'filterType',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la recherche type d\'événement'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'filterResponsable',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la recherche responsable'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'filterProduct',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la recherche produit'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'filterPlugin',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Activer la recherche extension'),
                                value: null,
                                onChange: function () {}
                            },
                            {
                                id: 'forceFilter',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Forcer les filtres'),
                                value: null,
                                onChange: function () {}
                            }
                        ]
                    }
                }
            }
        },
        computed: {
        },
        methods: {
            onRequestSuccess(data) {
                if (data.placeIsEnabled !== undefined) {
                    Core.Session.Setting.setSetting('event.placeIsEnabled',data.placeIsEnabled)
                }
                if (data.seasonIsEnabled !== undefined) {
                    Core.Session.Setting.setSetting('event.seasonIsEnabled',data.seasonIsEnabled)
                }
                if (data.leagueIsEnabled !== undefined) {
                    Core.Session.Setting.setSetting('event.leagueIsEnabled',data.leagueIsEnabled)
                }
                this.$refs.event.$parent.$parent.$parent.$parent.$parent.navItems = []
                this.$refs.event.$parent.$parent.$parent.$parent.$parent.navItems = nav.getNav()
            }
        }
    }
</script>
